module.exports = __webpack_public_path__ + "static/media/bg6.d997ae7b.jpg";